<template>
  <div class="light-timer">
    <div class="light-timer__item">{{minutesFormat}}</div>
    :
    <div class="light-timer__item">{{secondsFormat}}</div>
  </div>
</template>

<script>
  export default {
    props: {
      durationS: {
        type: Number,
        required: true
      }
    },
    data() {
      return {
        timer: null,
        value: 0
      }
    },
    computed: {
      minutesFormat() {
        return Math.floor(this.value / 60).toString().padStart(2, '0')
      },
      secondsFormat() {
        return Math.ceil(this.value % 60).toString().padStart(2, '0')
      }
    },
    created() {
      this.value = this.durationS

      this.timer = setInterval(() => {
        if(this.value < 1) {
          clearInterval(this.timer)
          this.$emit('end')
          return
        }
        this.value -= 1
      }, 1000)
    },
    beforeDestroy() {
      clearInterval(this.timer)
    }
  }
</script>

<style lang="less">

</style>